import PropTypes from 'prop-types';
import { FormGroup, Toggle } from '@celltrak/ui-components';
import noop from 'lodash/noop';

import { credentialForm } from '../../constants';

const SplitVisitToggle = ({ isChecked, onChange }) => (
  <FormGroup>
    <div>
      <Toggle
        id={credentialForm.splitVisitId}
        size="sm"
        label={credentialForm.splitVisitLabel}
        checked={isChecked}
        onChange={onChange}
      />
    </div>
  </FormGroup>
);

SplitVisitToggle.propTypes = {
  isChecked: PropTypes.bool,
  onChange: PropTypes.func,
};

SplitVisitToggle.defaultProps = {
  isChecked: false,
  onChange: noop,
};

export default SplitVisitToggle;
